import { myClientStorage } from '@/scripts/utils/storage/client';

export const userStorage_client = myClientStorage.getModule('user');
export const mediaCS = myClientStorage.getModule('media');
